import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const CURSOR_OFFSET_PX = 12;

interface MouseTrackingOverlayProps {
  children: React.ReactNode;
}

function MouseTrackingOverlay({ children }: MouseTrackingOverlayProps): React.ReactElement | null {
  const [position, setPosition] = useState<{ x: number; y: number } | undefined>(undefined);

  useEffect(() => {
    function handleMouseMove(event: MouseEvent): void {
      setPosition({ x: event.clientX, y: event.clientY });
    }

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('touchmove', handleTouchMove);

    function handleTouchMove(event: TouchEvent): void {
      const touch = event.touches[0];
      setPosition({ x: touch.clientX, y: touch.clientY });
    }

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('touchmove', handleTouchMove);
    };
  }, []);

  if (position === undefined) return null;

  return createPortal(
    <div
      style={{
        position: 'fixed',
        top: position.y + CURSOR_OFFSET_PX,
        left: position.x + CURSOR_OFFSET_PX,
        pointerEvents: 'none',
        zIndex: 9999,
      }}
    >
      {children}
    </div>,
    document.body,
  );
}

export default MouseTrackingOverlay;
